"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractsConverter = void 0;
const index_1 = __importDefault(require("../../dayjs/index"));
const Contract_1 = require("./model/Contract");
const EditingRestrictions_1 = require("./model/EditingRestrictions");
class ContractsConverter {
    static formatDates(contractDates) {
        return {
            start: contractDates?.start?.format('YYYY-MM-DD'),
            end: contractDates?.end?.format('YYYY-MM-DD'),
        };
    }
    static parseDates(resource) {
        return {
            start: resource?.start
                ? ContractsConverter.parseOrThrow(resource.start)
                : undefined,
            end: resource?.end
                ? ContractsConverter.parseOrThrow(resource.end)
                : undefined,
        };
    }
    static parseOrThrow(dateString) {
        const parsed = (0, index_1.default)(dateString);
        if (!parsed.isValid()) {
            throw Error(`Unable to parse date string: ${dateString}`);
        }
        return parsed;
    }
    static fromResource(resource) {
        const { contractDates, _links, restrictions, ...rest } = resource;
        const dates = contractDates
            ? ContractsConverter.parseDates(contractDates)
            : undefined;
        const domainRestrictions = restrictions
            ? ContractsConverter.convertRestrictions(restrictions)
            : undefined;
        return {
            ...rest,
            id: { value: rest.id },
            contractDates: dates,
            restrictions: domainRestrictions,
        };
    }
    static convertRestrictions(restrictions) {
        return {
            ...restrictions,
            editingRestrictions: {
                permission: restrictions?.editingRestrictions?.permission && {
                    value: ContractsConverter.convertEditingPermissionsType(restrictions?.editingRestrictions?.permission?.value),
                    label: restrictions?.editingRestrictions?.permission?.label || '',
                },
                editingInfo: restrictions?.editingRestrictions.editingInfo,
            },
            territoryRestrictions: {
                restrictionsType: ContractsConverter.convertTerritoryRestrictionsType(restrictions?.territoryRestrictions?.restrictionsType),
                territories: restrictions?.territoryRestrictions?.territories,
            },
            aiRestrictions: {
                internalUse: ContractsConverter.convertToAiPermissionsType(restrictions?.aiRestrictions?.internalUse),
                llmUse: ContractsConverter.convertToAiPermissionsType(restrictions?.aiRestrictions?.llmUse),
                info: restrictions?.aiRestrictions?.info,
            },
        };
    }
    static convertToAiPermissionsType(stringValue) {
        if (stringValue === undefined || stringValue === null) {
            return undefined;
        }
        return Contract_1.AiPermissionsType[stringValue];
    }
    static convertTerritoryRestrictionsType(stringValue) {
        switch (stringValue) {
            case 'RESTRICTED':
                return Contract_1.TerritoryRestrictionsType.RESTRICTED;
            case 'NO_RESTRICTIONS':
                return Contract_1.TerritoryRestrictionsType.NO_RESTRICTIONS;
            case undefined:
            case null:
                return undefined;
            default:
                throw Error(`Unknown territory restrictions type: ${stringValue}`);
        }
    }
    static convertEditingPermissionsType(stringValue) {
        return EditingRestrictions_1.EditingPermissionType[stringValue];
    }
}
exports.ContractsConverter = ContractsConverter;
//# sourceMappingURL=ContractsConverter.js.map